export const common = {
  nav: {
    home: 'Home',
    about: 'Over Ons',
    solutions: 'Oplossingen',
    pricing: 'Prijzen',
    contact: 'Contact'
  },
  footer: {
    solutions: 'Oplossingen',
    company: 'Bedrijf',
    contact: 'Contact Ons',
    allRightsReserved: 'Alle rechten voorbehouden',
    marketAnalysis: 'Marktanalyse',
    leadEnablement: 'Lead Enablement',
    businessIntelligence: 'Business Intelligence',
    strategicSupport: 'Strategische Ondersteuning',
    about: 'Over Ons',
    privacyPolicy: 'Privacybeleid',
    termsOfService: 'Algemene Voorwaarden'
  },
  contact: {
    phone: 'Telefoon',
    email: 'Email',
    address: 'Adres'
  }
};
